var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto"},[_c('v-card-title',[_c('v-toolbar-title',[_vm._v("My Payroll Remittances")]),_c('v-spacer'),_c('download-zip-button',{attrs:{"selectedFiles":_vm.selectedItems}})],1),_c('payroll-remittances-table',{on:{"toggleSelection":_vm.toggleSelection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }